import React from 'react'
import { Button, Icon } from '@mui/material'

export const FormSection = ({ title, icon, className, children, rightTitle, style, titleStyle, little, align }) => (
  <div
    className={'formSection ' + (typeof little !== 'undefined' ? 'col-md-6' : 'col-md-12') + ' ' + (typeof className !== 'undefined' ? className : '')}
    style={style}
  >
    <div className="desc-icon" style={{ textAlign: align }}>
      {icon && <i className={icon} />}
      {title && (
        <h2 style={{ ...titleStyle }}>
          {title} {rightTitle && <div>{rightTitle}</div>}
        </h2>
      )}
    </div>

    <div className="autocomp">{children}</div>
  </div>
)

export const ButtonIcon = ({ icon, style, iconStyle, href, onClick, disabled, testId }) => (
  <Button href={href} target="_blank" iconClassName={icon} style={style} disabled={disabled} onClick={onClick} data-testid={testId}>
    <Icon className={icon} style={{ ...iconStyle }} />
  </Button>
)
